import React, { useState, useEffect } from "react";
import PopUpContainerNotifications from "components/Reusable/Notifications/PopUpNotifications/PopUpContainerNotifications.js";
import { getSpecialNotification } from "components/Reusable/Notifications/Helpers.js";
import { useUser } from "contexts/userContext/userContext.js";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { useCookie } from "contexts/cookieContext/cookieContext.js";

const NOTIFICATION_SYSTEM_NAME = "specialsubscriptionpurchase";

const SpecialNotification = ({
  notificationSystemName = NOTIFICATION_SYSTEM_NAME,
  isActive = false,
  destinationUrl = null,
}) => {
  const { getCookie } = useCookie();
  const { getUserData, isLoggedIn } = useUser();
  const { setModal } = useModal();
  const { getLanguage } = useContent();
  const [specialNotification, setSpecialNotification] = useState(null);
  const [notExistSegnments, setNotExistSegnments] = useState(false);
  useEffect(() => {
    if (isActive && notificationSystemName) {
      let userId = 0;
      if (!isLoggedIn()) {
        //get from cookie ActiveUserPromotion
        const senderId = getCookie("ActiveUserPromotion");
        userId = senderId ? senderId : 0;
      } else {
        userId = getUserData().UserId;
      }
      getSpecialNotification({
        userId: userId,
        notification: notificationSystemName,
        culture: getLanguage(),
        setSpecialNotification,
        setNotExistSegnments,
      });
    }
  }, [isActive, notificationSystemName, getUserData, getLanguage, isLoggedIn]);

  useEffect(() => {
    if (specialNotification) {
      let tempNotification = { ...specialNotification };
      tempNotification.NotificationImage = null;
      tempNotification.NotificationTitle = null;
      tempNotification.NotificationText = specialNotification.NotificationText;
      tempNotification.NotificationLinkUrl =
        specialNotification.NotificationLinkUrl;
      tempNotification.CancelDestinationUrl = destinationUrl;
      tempNotification.NotificationLinkTarget = "blank";
      displaySpecialNotification({
        notificationDetails: tempNotification,
      });
    }
  }, [specialNotification]);

  useEffect(() => {
    if (notExistSegnments) {
      window.location.href = destinationUrl;
    }
  }, [notExistSegnments]);

  const displaySpecialNotification = ({ notificationDetails }) => {
    if (notificationDetails) {
      setModal({
        modal: PopUpContainerNotifications,
        modalOverlayClass: `marketing-modal-overlay`,
        props: {
          data: notificationDetails,
          previewAdmin: true,
          isSpecial: true,
        },
      });
    }
  };
  return <></>;
};

export default SpecialNotification;
